"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var http_1 = require("@angular/common/http");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var Observable_1 = require("rxjs/Observable");
var operators_1 = require("rxjs/operators");
var HttpRelatedEntityService = /** @class */ (function () {
    function HttpRelatedEntityService(http, applicationPropertiesService, _currentLanguageProvider) {
        this.http = http;
        this.applicationPropertiesService = applicationPropertiesService;
        this._currentLanguageProvider = _currentLanguageProvider;
        this.idmCmsServiceUrlKey = 'cms-service-url';
        this.idmCmsServiceUrl$ = Observable_1.Observable.from(this.applicationPropertiesService.getProperty(this.idmCmsServiceUrlKey));
    }
    HttpRelatedEntityService.prototype.getRelatedEntitiesByInstanceId = function (categoryId, entityInstanceId, relatedCategories, nocache) {
        var _this = this;
        if (nocache === void 0) { nocache = false; }
        return this.idmCmsServiceUrl$.pipe(operators_1.mergeMap(function (cmsServiceUrl) {
            var url = cmsServiceUrl + '/derivatives/' + categoryId + '/' + entityInstanceId;
            var headers = new http_1.HttpHeaders({ 'Content-Type': 'application/json' });
            var params = new http_1.HttpParams()
                .set('relatedCategories', relatedCategories.join(','))
                .set('nocache', "" + nocache);
            var options = { headers: headers, params: params };
            return _this.http.get(url, options);
        }));
    };
    HttpRelatedEntityService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.HttpClient,
            idm_application_properties_service_client_js_1.ApplicationPropertiesService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider])
    ], HttpRelatedEntityService);
    return HttpRelatedEntityService;
}());
exports.HttpRelatedEntityService = HttpRelatedEntityService;
//# sourceMappingURL=http-related-entity.service.js.map